import { Flex, FlexProps } from '@blockanalitica/ui';
import { useMemo } from 'react';
import { NavLink as RouterNavLink } from 'react-router';
import styled, { css } from 'styled-components';
import { NavigationRoute } from './Navigation';

export interface MobileNavigationProps extends FlexProps {
  routes: NavigationRoute[];
}

const StyledIcon = styled(Flex)`
  color: ${({ theme }) => theme.colors.muted};
`;

const Category = styled(Flex)<FlexProps>`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.border};
    padding-bottom: ${theme.space['m']};
  `}
`;

const NavCategory = styled(Flex)<FlexProps>`
  text-decoration: none;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  width: 100%;

  ${({ theme }) => css`
    gap: ${theme.space['2xs']};
    color: ${theme.colors.text};
    font-size: ${theme.sizes['1']};

    &.active,
    &.active ${StyledIcon} {
      position: relative;
      color: ${theme.colors.primary};
    }
  `}
`;

const NavLink = styled(RouterNavLink)`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  ${({ theme }) => css`
    gap: ${theme.space['2xs']};
    color: ${theme.colors.text};
    font-size: ${theme.sizes['1']};

    &:hover,
    &:hover ${StyledIcon} {
      color: ${theme.colors.linkHover};
    }

    &.active,
    &.active ${StyledIcon} {
      position: relative;
      color: ${theme.colors.primary};
    }
  `}
`;

export default function MobileNavigation({ routes }: MobileNavigationProps) {
  const networkRoutes = useMemo(
    () =>
      routes.map((route) => ({
        ...route,
        linkTo: route.linkTo === '/' ? route.linkTo : `${route.linkTo}`
      })),
    [routes]
  );

  return (
    <Flex alignItems="flex-start" gap="m" width="100%" flexDirection="column">
      {networkRoutes.map((route) => {
        if (route.subRoutes && route.subRoutes.length > 0) {
          return (
            <Category
              flexDirection="column"
              gap="s"
              width="100%"
              key={`mobile-${route.title}`}>
              <NavCategory>{route.title}</NavCategory>
              {route.subRoutes.map((subRoute) => (
                <NavLink
                  key={`mobile-${subRoute.linkTo}`}
                  to={subRoute.linkTo}
                  end={subRoute.end}>
                  <StyledIcon>{subRoute.icon}</StyledIcon>
                  {subRoute.title}
                </NavLink>
              ))}
            </Category>
          );
        } else {
          return (
            <NavLink
              key={`mobile-${route.linkTo}`}
              to={route.linkTo}
              end={route.end}>
              <StyledIcon>{route.icon}</StyledIcon>
              {route.title}
            </NavLink>
          );
        }
      })}
    </Flex>
  );
}
